<h1 mat-dialog-title>{{ 'labels.heading.Unassign Role' | translate }}</h1>
<div mat-dialog-content>
  <p>{{ 'labels.text.Unassign role for client member' | translate }}: {{ data.id }} ?</p>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>{{ 'labels.buttons.Cancel' | translate }}</button>
  <button mat-raised-button color="warn" [mat-dialog-close]="{ confirm: true }">
    {{ 'labels.buttons.Confirm' | translate }}
  </button>
</mat-dialog-actions>
